import { type ISupportedLanguage } from '#app/utils/i18n.tsx'

export type DownloadableCategoryCode =
	| 'catalogs'
	| 'technical-sheets'
	| 'video'
	| 'extra'

export class DownloadableCategory {
	static readonly CATALOG = new DownloadableCategory('catalogs', {
		en: 'Catalog of products',
		it: 'Catalogo prodotti',
		de: 'Katalog von Produkten',
		fr: 'Catalogue de produits',
		es: 'Catálogos de productos',
	})

	static readonly TECHNICAL_SHEET = new DownloadableCategory(
		'technical-sheets',
		{
			en: 'Technical sheet',
			it: 'Scheda tecnica',
			de: 'Technisches Datenblatt',
			fr: 'Fiche technique',
			es: 'Documentación técnica',
		},
	)

	static readonly ENVIRONMENTAL_CERTIFICATIONS = new DownloadableCategory(
		'environmental-certifications',
		{
			en: 'Environmental Certifications',
			it: 'Certificazioni ambientali',
			de: 'Umweltzertifizierungen',
			fr: 'Certifications environnementales',
			es: 'Certificaciones ambientales',
		},
	)

	private constructor(
		public readonly code: string,
		public readonly labels: {
			en: string
			it: string
			de: string
			fr: string
			es: string
		},
	) {}

	static getAll(): DownloadableCategory[] {
		// Don't show ENVIRONMENTAL CERTIFICATIONS because we don't want to enable that category for the dynamic admin configuration.
		return [this.CATALOG, this.TECHNICAL_SHEET]
	}

	static getAllCodes(): string[] {
		return this.getAll().map((category) => category.code)
	}

	static getSelectOptions(
		locale: ISupportedLanguage,
	): { value: string; label: string }[] {
		return this.getAll().map((category) => ({
			value: category.code,
			label: category.labels[locale],
		}))
	}

	static getByCode(code: string): DownloadableCategory | undefined {
		return this.getAll().find((category) => category.code === code)
	}
}
